import React, { Component } from 'react'
import Lightbox from "react-image-lightbox";
import 'react-image-lightbox/style.css';

import azonthumb from "../../assets/layouts/azon-thumb.png";
import kubanthumb from "../../assets/layouts/kuban-thumb.png";
import prothumb from "../../assets/layouts/pro.png";
import azon from "../../assets/layouts/azon.png";
import kuban from "../../assets/layouts/kuban.png";
import schat from "../../assets/layouts/schat.png";
import schatthumb from "../../assets/layouts/schat-thumb.png";

import azonthumbwebp from "../../assets/layouts/azon-thumb.webp";
import kubanthumbwebp from "../../assets/layouts/kuban-thumb.webp";
import prothumbwebp from "../../assets/layouts/pro.webp";
import schatthumbwebp from "../../assets/layouts/schat-thumb.webp";

const images = [
  azon,
  kuban,
  prothumb,
  schat,
];

const titles = [
  <span>
    <a
      rel="noopener noreferrer"
      target="_blank"
      href="http://www.agnieszkazon.pl/"
    >
      Agnieszkazon.pl
    </a>{" "}
    <span>- Pracownia projektowa</span>
  </span>,
  <span>
    <a
      rel="noopener noreferrer"
      target="_blank"
      href="http://www.karczmakuban.pl/"
    >
      Karczmakuban.pl
    </a>{" "}
    <span>- Tradycyjna polska kuchnia</span>
  </span>,
  <span>
    <a
      rel="noopener noreferrer"
      target="_blank"
      href="http://www.pro-kierowca.pl/"
    >
      PRO-Kierowca.pl
    </a>{" "}
    <span>- Szkoła jazdy</span>
  </span>,
  <span>
    <a
      rel="noopener noreferrer"
      target="_blank"
      href="https://github.com/fifcio13/SChat"
    >
      SChat
    </a>{" "}
    <span>- Aplikacja czatu online</span>
  </span>,
];

export class Works extends Component {

  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
    };
  }

  render() {

    const { photoIndex, isOpen } = this.state;

    return (
      <section id="works">
        <div className="content-wrapper container">
          <aside>
            <h2 className="title">Moje projekty</h2>
            <span>* wybrane</span>
          </aside>
          <div className="content">
            <div className="items">
              <div className="item">
                <picture>
                  <source srcSet={azonthumbwebp} type="image/webp" />
                  <img
                    src={azonthumb}
                    role="button"
                    alt="Agnieszka Zon strona internetowa"
                    onClick={(e) =>
                      this.setState({
                        isOpen: true,
                        photoIndex: 0,
                      })
                    }
                  />
                </picture>
              </div>
              <div className="item">
                <picture>
                  <source srcSet={kubanthumbwebp} type="image/webp" />
                  <img
                    src={kubanthumb}
                    role="button"
                    alt="Karczma Kuban strona internetowa"
                    onClick={(e) =>
                      this.setState({
                        isOpen: true,
                        photoIndex: 1,
                      })
                    }
                  />
                </picture>
              </div>
              <div className="item">
                <picture>
                  <source srcSet={prothumbwebp} type="image/webp" />
                  <img
                    src={prothumb}
                    role="button"
                    alt="Pro-kierowca strona internetowa"
                    onClick={(e) =>
                      this.setState({
                        isOpen: true,
                        photoIndex: 2,
                      })
                    }
                  />
                </picture>
              </div>
              <div className="item">
                <picture>
                  <source srcSet={schatthumbwebp} type="image/webp" />
                  <img
                    src={schatthumb}
                    role="button"
                    alt="SChat czat internetowy"
                    onClick={(e) =>
                      this.setState({
                        isOpen: true,
                        photoIndex: 3,
                      })
                    }
                  />
                </picture>
              </div>
            </div>

            {isOpen && (
              <Lightbox
                mainSrc={images[photoIndex]}
                imageTitle={titles[photoIndex]}
                nextSrc={images[(photoIndex + 1) % images.length]}
                prevSrc={
                  images[(photoIndex + images.length - 1) % images.length]
                }
                onCloseRequest={() => this.setState({ isOpen: false })}
                onMovePrevRequest={() =>
                  this.setState({
                    photoIndex:
                      (photoIndex + images.length - 1) % images.length,
                  })
                }
                onMoveNextRequest={() =>
                  this.setState({
                    photoIndex: (photoIndex + 1) % images.length,
                  })
                }
                enableZoom={false}
              />
            )}
          </div>
        </div>
      </section>
    );
  }
}

export default Works
